import { httpsCallable } from 'firebase/functions';

import { getFunctions } from './helpers';

// Reading a claim does not spend it, so a page reload cannot cost the buyer their account.
export const getSignupClaim = async (claimToken: string) => {
  const get = httpsCallable<{ claimToken: string }, { email: string }>(
    getFunctions(),
    'stripe-getSignupClaim',
  );

  const { data } = await get({ claimToken });

  return data.email;
};
